"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
var React = __importStar(require("react"));
var isBrowser = function () {
    return typeof document !== 'undefined' && typeof window !== 'undefined';
};
var ScriptProvider = function (_a) {
    var children = _a.children, onLoad = _a.onLoad, source = _a.source, sourceId = _a.sourceId;
    var _b = __read(React.useState(false), 2), isLoadingComplete = _b[0], setLoadingComplete = _b[1];
    var loadScriptCallback = function () {
        if (onLoad) {
            onLoad();
        }
        setLoadingComplete(true);
    };
    React.useEffect(function () {
        if (!isBrowser() || !source || !sourceId) {
            return;
        }
        var existingElement = document.querySelector("#" + sourceId) ||
            document.querySelector("script[src=\"" + source + "\"]");
        var scriptNode = null;
        if (!existingElement) {
            scriptNode = document.createElement('script');
            scriptNode.type = 'text/javascript';
            scriptNode.src = source;
            scriptNode.id = sourceId;
            scriptNode.addEventListener('load', loadScriptCallback);
            document.body.appendChild(scriptNode);
        }
        if (existingElement) {
            loadScriptCallback();
        }
        return function () {
            // The script provider does not need to care about removing the script,
            // if it did not bring it in.
            if (!existingElement && scriptNode) {
                scriptNode.removeEventListener('load', loadScriptCallback);
                var sourceElement = document.querySelector("#" + sourceId);
                if (sourceElement) {
                    document.body.removeChild(sourceElement);
                }
            }
        };
    }, []);
    if (isBrowser() && isLoadingComplete) {
        return children;
    }
    return null;
};
exports["default"] = ScriptProvider;
